export default {

    start: () => {

        $(window).on('load', () => {

            $('#app').on('scroll', () => {

                var sectionArr      = calcSections('app');

                var scrollHeight    = document.getElementById('app').scrollHeight;
                var scrollTop       = $('#app').scrollTop();
                var height          = $('#app').height();
                var top             = $('#app').position().top;

                var percentage      = scrollTop / (scrollHeight - height);
                if (percentage > 1)
                    percentage      = 1;

                var id;
                var match = false;

                for (var i=0; i<sectionArr.length; i++) {

                    id = sectionArr[i].id;
                    if (percentage >= sectionArr[i].top && percentage <= sectionArr[i].bottom) {

                        if (!$('#nav-'+id).hasClass('header__nav--current'))
                            $('#nav-'+id).addClass('header__nav--current');

                        if (!$('#mobile-nav-'+id).hasClass('mobile-nav__current'))
                            $('#mobile-nav-'+id).addClass('mobile-nav__current');
                    } else {
                        if ($('#nav-'+id).hasClass('header__nav--current'))
                            $('#nav-'+id).removeClass('header__nav--current');

                        if ($('#mobile-nav-'+id).hasClass('mobile-nav__current'))
                            $('#mobile-nav-'+id).removeClass('mobile-nav__current');
                    }
                }
            })
        })

        function calcSections(id) {
            var scrollHeight    = document.getElementById('app').scrollHeight;
            var scrollTop       = $('#app').scrollTop();
            var height          = $('#app').height();
            var top             = $('#app').position().top;

            var sectionArr      = [];

            var divs            = $('#'+id+' section');
            divs.each(function() {

                var top     = ($(this).position().top + scrollTop) / scrollHeight;
                var bottom  = (($(this).position().top + scrollTop) + $(this).outerHeight() - 1) / scrollHeight;

                sectionArr.push({
                    id      : $(this).attr('id'),
                    top     : top < 0.02 ? 0 : parseFloat(top.toFixed(2))+0.01,
                    bottom  : bottom > .98 ? 1 : parseFloat(bottom.toFixed(2))
                });
            });

            return sectionArr;
        }
    }
}



// WEBPACK FOOTER //
// ./ui_src/app/utils/ScrollListener.jsx